import { render } from "./ClubsIndex.vue?vue&type=template&id=6fcd4874"
import script from "./ClubsIndex.vue?vue&type=script&lang=js"
export * from "./ClubsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corrieleech/Actualize/booksmart-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__